export default __webpack_public_path__ + "static/9-334928a3303f485e1002aa1ff6c1e3a7.jpg";